import { render, staticRenderFns } from "./MenuProductos.vue?vue&type=template&id=249612d6&scoped=true&"
import script from "./MenuProductos.vue?vue&type=script&lang=js&"
export * from "./MenuProductos.vue?vue&type=script&lang=js&"
import style0 from "./MenuProductos.vue?vue&type=style&index=0&id=249612d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249612d6",
  null
  
)

/* custom blocks */
import block0 from "./MenuProductos.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports